import React from "react";
import Button from '@mui/material/Button';
import { auth } from "./firebase.js";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import GoogleIcon from '@mui/icons-material/Google';
import { Box } from "@mui/material";


function SignIn() {
    const signInWithGoogle = () => {
        const provider = new GoogleAuthProvider();
        auth.languageCode = 'es';
        signInWithPopup(auth, provider).catch(console.error);
    }
    return (
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column", gap:5 }}>
            <img style={{ height: '10em' }} src="/logo.png" alt="logo" />
            <Button
                variant="contained"
                startIcon={<GoogleIcon />}
                onClick={signInWithGoogle}
                sx={{
                    color:'white'
                    // m: 'auto',
                }}
                id="sign-in-button"
            >Inicia Sesión</Button>
        </Box>
    );
}

export default SignIn;
